import React, { Component } from 'react';

import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';

import validate from './Validations/submitValidationRenaperDocumentInformation';

import Section from './Section';
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner.js';
import CustomAlert from '../components/CustomAlert.js';

class RenaperDocumentInformation extends Component {
  constructor(props){
    super(props);

    this.state = {
      loading: false,
      error: false,
      form: {
        renaper_document_number: {
          value: null,
          meta: {}
        },
        renaper_process_number: {
          value: null,
          meta: {}
        },
        renaper_name: {
          value: null,
          meta: {}
        },
        renaper_lastname: {
          value: null,
          meta: {}
        },
        renaper_birth_date: {
          value: null,
          meta: {}
        },
        renaper_browser_fingerprint: {
          value: null,
          meta: {}
        },
      }
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setBrowserFingerPrint = this.setBrowserFingerPrint.bind(this);
  }

  componentDidMount(){
    console.log(window.VUBrowserFP);
    var vuFp = new window.VUBrowserFP(); 
    vuFp.getFingerprintInfoWithSeed(this.setBrowserFingerPrint);  
  }

  handleChange(event, inputName){
    let inputData = {};
    inputData[inputName] = {
      value: event.target.value,
      meta: {
        touched: true
      }
    }

    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        ...inputData
      }
    });
  }

  handleSubmit(event){
    event.preventDefault();
    const { form } = this.state;
  
    this.setState({
      ...this.state,
      loading: true,
    });

    const ROOT_URL = process.env.API_URL;

    const config = {
        headers:
            {
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                'Content-Type': 'application/json'
            }
    };

    let body = {}

    Object.keys(form).forEach((key) => {
      body[key] = form[key].value
    });

    const errors = validate(body);

    if(Object.entries(errors).length !== 0){

      let updatedForm = {...form};
 
      Object.keys(errors).forEach((key) => {
        updatedForm[key]['meta'] = {
          error: errors[key],
          touched: true,
          invalid: true,
        }
      });

      this.setState({
        ...this.state,
        error: 'Revisá los campos indicados.',
        form: updatedForm
      });

      return
    }

    axios.post(`${ROOT_URL}/identity/renaper/document_information`, body, config)
    .then((response)=> {
      this.props.onFinish();
    });
  }

  setBrowserFingerPrint(browserInfo){
    const { form } = this.state;
     
    var result =  browserInfo.fingerprint; //Información a enviar al server en Base64              			 	
    this.setState({
      ...this.state,
      form: {
        ...form,
        renaper_browser_fingerprint: {
          value: result,
          meta: {}
        }
      }
    })
  }

  render() {
    const { form, loading, error } = this.state;

    return (
      <div style={{
        position: "relative",
        display: "block",
        width: "100%",
        height: "100%",
        overflowY: "scroll",
        background: "#ffffff",
      }}>
      <Section className="intro_form">
          <div className="row">
              <div className="pd-content-left col-sm-12 col-md-5 col-lg-5 text-center">
                  <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                  <FormattedHTMLMessage id="app.step_renaper_document_information" description="Renaper document information"/>
              </div>
              <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                  <form onSubmit={this.handleSubmit} className="pvc-form">
                    {loading && <CustomSpinner message='Estamos analizando los datos. Por favor espere...' />}
                    {error && <CustomAlert bsStyle="danger" message={error}/>}
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                              <RenderField 
                                type="number" 
                                name="renaper_document_number" 
                                label="Número de Documento"
                                input={{
                                  onChange: (event) => {this.handleChange(event, 'renaper_document_number')},
                                  value: form.renaper_document_number.value
                                }}
                                meta={{
                                  ...form.renaper_document_number.meta,
                                  asyncValidating: false
                                }}/>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                              <RenderField 
                                type="number"
                                name="renaper_process_number"
                                label="Numero de Trámite"
                                input={{
                                  onChange: (event) => {this.handleChange(event, 'renaper_process_number')},
                                  value: form.renaper_process_number.value
                                }}
                                meta={{
                                  ...form.renaper_process_number.meta,
                                  asyncValidating: false 
                                }}/>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                              <RenderField
                                type="text"
                                name="renaper_name"
                                label="Nombre/s como figura en el DNI."
                                input={{
                                  onChange: (event) => {this.handleChange(event, 'renaper_name')},
                                  value: form.renaper_name.value
                                }}
                                meta={{
                                  ...form.renaper_name.meta,
                                  asyncValidating: false 
                                }}/>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                              <RenderField
                                type="text"
                                name="renaper_lastname"
                                label="Apellido/s como figura en el DNI."
                                input={{
                                  onChange: (event) => {this.handleChange(event, 'renaper_lastname')},
                                  value: form.renaper_lastname.value
                                }}
                                meta={{
                                  ...form.renaper_lastname.meta,
                                  asyncValidating: false 
                                }}/>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                              <RenderField 
                                type="simple_date"
                                name="renaper_birth_date"
                                label="Fecha de Nacimiento."
                                input={{
                                  onChange: (event) => {this.handleChange(event, 'renaper_birth_date')},
                                  value: form.renaper_birth_date.value
                                }}
                                meta={{
                                  ...form.renaper_birth_date.meta,
                                  asyncValidating: false 
                                }}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                            <button 
                              type="submit"
                              className="btn btn-warning btn-lg pd-button pd-form"
                              disabled={false}>
                                Seguir
                            </button>
                        </div>
                    </div>
                  </form>
              </div>
          </div>
      </Section>
      </div>
    );

  }
}
module.exports = RenaperDocumentInformation



/** WEBPACK FOOTER **
 ** ./src/components/RenaperDocumentInformation.js
 **/